// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px 20px;
  background: white;
  margin: 0;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 28px;
  line-height: 35px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--ion-color-primary);
  margin-bottom: 8px;
}

.info {
  font-family: AppFont, sans-serif;
  font-size: 20px;
  margin-top: 20px;
  line-height: 30px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--order-list-option-name-color);
  margin-bottom: 35px;
}

.button {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: var(--ion-color-primary);
  font-family: Slat;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #f4ece1;
}
.button_close {
  background: var(--ion-color-tertiary);
  color: var(--ion-color-tertiary-contrast);
  min-height: 54px;
  font-family: var(--buttons-font-family) !important;
  text-align: center;
  font-size: var(--buttons-font-size);
  margin: 0;
  text-transform: var(--buttons-text-transform);
  color: var(--buttons-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EAEA,mBAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AADJ;AAIE;EACE,qCAAA;EAEA,yCAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;EAEA,mCAAA;EACA,SAAA;EACA,6CAAA;EACA,gCAAA;AAJJ","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 20px 20px;\n  background: white;\n  margin: 0;\n}\n\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 28px;\n  line-height: 35px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--ion-color-primary);\n  margin-bottom: 8px;\n}\n\n.info {\n  font-family: AppFont, sans-serif;\n  font-size: 20px;\n  margin-top: 20px;\n  line-height: 30px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--order-list-option-name-color);\n\n  margin-bottom: 35px;\n}\n\n.button {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main {\n    background: var(--ion-color-primary);\n    font-family: Slat;\n    font-size: 20px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: #f4ece1;\n  }\n\n  &_close {\n    background: var(--ion-color-tertiary);\n\n    color: var(--ion-color-tertiary-contrast);\n    min-height: 54px;\n    font-family: var(--buttons-font-family) !important;\n    text-align: center;\n\n    font-size: var(--buttons-font-size);\n    margin: 0;\n    text-transform: var(--buttons-text-transform);\n    color: var(--buttons-text-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
